import { useEffect, useMemo, useState } from "react";
import { Link, useParams,useLocation } from "react-router-dom";

import toast from "react-hot-toast";
import { addTowishlistApi } from "../../../ApiService/addtowishlist/addtowishlist";
import { getProductsdetail } from "../../../ApiService/productdetail/productdetail";
import ArrivalItem from "../../../components/arrival-item";
import BottomNav from "../../../components/bottomnav.jsx";
import Footer from "../../../components/footer";
import Navbar from "../../../components/navbar";
import ProductAboutTab from "../../../components/product-about-tab";
import ProductDetail from "../../../components/product-detail";
import ScrollToTop from "../../../components/scroll-to-top";
import Switcher from "../../../components/switcher";
export default function ProductDetailThree() {
  const { product_id } = useParams();
  console.log("product_id from useParams:", product_id);
  const [activeImage, setActiveImage] = useState(null);
  const [products, setProducts] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [isFavorite, setIsFavorite] = useState(false);
  const location = useLocation();
  console.log(products, "Products data");

  let path = null;

  if(location.pathname.includes("/products/")){
    path = 'allproducts';
  }
  else if (location.pathname.includes("/category/")){
    const id = location.pathname.split("/").pop();
    path = 'category'+ id
  }
  else if (location.pathname.includes("/subcategory/")){
    const id = location.pathname.split("/").pop();
    path = 'subcategory' + id
  }
  else if(location.pathname.includes("/brand/")){
    const id = location.pathname.split("/").pop();
    path = 'brand'+ id
  }


  useEffect(() => {
    const getProduct = async () => {
      if (!product_id) return;

      try {
        const data = await getProductsdetail(product_id);
        console.log("Fetched product data:", data);
        setProducts(data);
        if (data.variants?.length > 0) {
          setSelectedColor(data.variants[0].color);
        }
      } catch (error) {
        console.error("Error fetching product:", error);
      }
    };

    getProduct();
  }, [product_id]);

  const BASE_MEDIA_URL = process.env.REACT_APP_MEDIA_BASE_URL;

  const images = useMemo(() => {
    return (
      products?.variants?.find((v) => v.color === selectedColor) ||
      products?.variants?.[0]
    );
  }, [products, selectedColor]);

  const mappedImages = useMemo(() => {
    return (
      images?.images.map((img, index) => ({
        id: index,
        image: `${BASE_MEDIA_URL}${img}`,
      })) || []
    );
  }, [images, BASE_MEDIA_URL]);

  useEffect(() => {
    if (mappedImages.length > 0) {
      const newActiveImage = mappedImages[0].image;
      setActiveImage(newActiveImage);
      console.log(
        "Updated activeImage to:",
        newActiveImage,
        "for color:",
        selectedColor
      );
    } else {
      setActiveImage(null);
      console.log("No images available for color:", selectedColor);
    }
  }, [mappedImages, selectedColor]);

  const imageShow = (img) => {
    console.log("Thumbnail clicked, setting activeImage to:", img);
    setActiveImage(img);
  };

  console.log(
    "Current state - activeImage:",
    activeImage,
    "mappedImages:",
    mappedImages,
    "selectedColor:",
    selectedColor
  );
  const handleAddToWishlist = async () => {
    try {
      const customer_id = localStorage.getItem("customer_id");
      if (!customer_id) {
        console.error("No customer_id found — please login first!");
        toast.error("Please login first!", {
          position: "top-center",
          style: { borderRadius: "10px", background: "#333", color: "#fff" },
        });
        return;
      }

      // ✅ Pick SKU from currently selected variant + color
      const selectedVariant = products?.variants?.find(
        (v) => v.color === selectedColor
      );
      const sku_code =
        selectedVariant?.sizes?.[0]?.sku || selectedVariant?.sku_code || null;

      if (!sku_code) {
        console.error("SKU code missing!");
        toast.error("Please select a color/size first!", {
          position: "top-center",
          style: { borderRadius: "10px", background: "#333", color: "#fff" },
        });
        return;
      }

      const payload = {
        product_id: products?.product_id || products?.id,
        sku_code,
        customer_id,
      };

      console.log("🧡 Sending wishlist payload:", payload);

      const response = await addTowishlistApi(payload);

      if (response?.message) {
        setIsFavorite(true);
        toast.success("Added to wishlist ❤️", {
          position: "top-center",
          style: { borderRadius: "10px", background: "#333", color: "#fff" },
        });
      } else {
        toast.error(response?.error || "Failed to add to wishlist!", {
          position: "top-center",
          style: { borderRadius: "10px", background: "#333", color: "#fff" },
        });
      }
    } catch (error) {
      console.error("Wishlist API error:", error);
      toast.error("Something went wrong!", {
        position: "top-center",
        style: { borderRadius: "10px", background: "#333", color: "#fff" },
      });
    }
  };

  return (
    <>
      {/* <Tagline /> */}
      <Navbar navClass="defaultscroll is-sticky tagline-height" />
      <section className="relative table w-full py-2 lg:pt-24 lg:pb-2 md:pt-28 bg-gray-50 dark:bg-slate-800">
        <div className="container relative">
          <div className="grid grid-cols-1 mt-14">
            <h3 className="text-3xl leading-normal font-semibold">
              {products?.name || "Product Name"}
            </h3>
          </div>
          <div className="relative mt-3">
            <ul className="tracking-[0.5px] mb-0 inline-block">
              <li className="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out hover:text-green-500">
                <Link to="/">Sportyfi</Link>
              </li>
              <li className="inline-block text-base text-slate-950 dark:text-white mx-0.5 ltr:rotate-0 rtl:rotate-180">
                <i className="mdi mdi-chevron-right"></i>
              </li>
              <li className="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out hover:text-green-500">
                <Link to={`/shop-grid-left-sidebar/${path}`}>Store</Link>
              </li>
              <li className="inline-block text-base text-slate-950 dark:text-white mx-0.5 ltr:rotate-0 rtl:rotate-180">
                <i className="mdi mdi-chevron-right"></i>
              </li>
              <li
                className="inline-block uppercase text-[13px] font-bold text-green-500"
                aria-current="page"
              >
                {products?.name || "Product Name"}
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="relative md:py-12 py-8">
        <div className="container relative">
          <div className="grid md:grid-cols-2 grid-cols-1 gap-6 items-start">
            <div>
              {mappedImages.length > 0 ? (
                <ul className="product-imgs flex flex-col md:flex-row list-none">
                  {/* Thumbnails */}
                  <li className="md:w-1/6 w-full md:order-1 order-2 flex md:flex-col flex-row md:h-[450px] overflow-y-auto overflow-x-auto">
                    <ul className="img-select list-none flex md:flex-col flex-row">
                      {mappedImages.map((item) => (
                        <li
                          className="flex-shrink-0 md:w-full w-16"
                          key={item.id}
                        >
                          <button
                            type="button"
                            onClick={() => imageShow(item.image)}
                            className="block w-full h-full"
                          >
                            <img
                              src={item.image}
                              className={`shadow dark:shadow-gray-800 w-full md:h-20 h-16 object-cover rounded cursor-pointer ${
                                activeImage === item.image
                                  ? "ring-2 ring-orange-500"
                                  : ""
                              }`}
                              alt={`Thumbnail ${item.id}`}
                              onError={() =>
                                console.log(
                                  `Failed to load thumbnail: ${item.image}`
                                )
                              }
                            />
                          </button>
                        </li>
                      ))}
                    </ul>
                  </li>

                  {/* Main Display */}
                  <li className="img-display md:w-5/6 w-full md:order-2 order-1">
                    <div className="img-showcase relative w-full max-h-[450px] overflow-hidden flex duration-500">
                      {/* Main Product Image */}
                      <img
                        key={activeImage}
                        src={activeImage}
                        className="w-full h-auto object-contain rounded-none"
                        alt={products?.name || "Product Image"}
                      />

                      {/* Heart / Favorite Button */}
                      <button
                        type="button"
                        className="absolute top-3 right-3 bg-white p-2 rounded-full shadow-lg hover:scale-110 transition-transform"
                        onClick={handleAddToWishlist}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6 text-red-500"
                          fill={isFavorite ? "currentColor" : "none"}
                          stroke="currentColor"
                          strokeWidth={2}
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 
3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 
16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 
11.54L12 21.35z"
                          />
                        </svg>
                      </button>
                    </div>
                  </li>
                </ul>
              ) : (
                <p className="text-red-500 text-sm">
                  No product images available
                </p>
              )}
            </div>

            <div>
              <ProductDetail
                product={products}
                selectedColor={selectedColor}
                setSelectedColor={setSelectedColor}
              />
            </div>
          </div>
          <ProductAboutTab products={products} selectedColor={selectedColor} />
        </div>
        <ArrivalItem product={products} />
      </section>
      <BottomNav />
      <Footer />
      <Switcher />
      <ScrollToTop />
    </>
  );
}
